/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * Service.ts
 */

export interface Listener<E> {

}

export abstract class Service<E, L extends Listener<E>> {
    protected listeners: Array<L> = [];
    public started: Boolean = false;
    static id: string;

    public start() {
        this.started = true;
    };

    public stop() {
    };

    public addListener(listener: L) {
        const index = this.listeners.indexOf(listener);

        if (index < 0) {
            this.listeners.push(listener)
        }
    }

    public removeListener(listener: L) {
        const index = this.listeners.indexOf(listener);

        if (index > 0) {
            this.listeners.splice(index, 1)
        }
    }

}